export enum RegexTypeEnum {
    EMAIL_PATTERN = '^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',
    ORDERS_SEQUENCE_PATTERN = '^[AGTCagtc]*$',
    ORDERS_TRACKING_NUMBER = '^[0-9a-zA-Z]+$',
    ORDERS_INFORMED_USER_NAME = "^[A-Za-z.' -]+$",
}
